// white listing these routes as these are to executed in unifyapps context
const whitelistedRoutes = ['custom', 'standard', 'create', 'edit', 'share'];
// whitelisting Interface Activity Route, as we need to show Platform Users as filter instead of Application Users
const getIsWhitelistedRoute = (interfaceIdFromRoute: string, route: string) => {
  if (route.endsWith(`${interfaceIdFromRoute}/activity`)) return true;
  return whitelistedRoutes.some((it) => it === interfaceIdFromRoute);
};

export const extractInterfaceFromRoute = (route: string): string | null | undefined => {
  const params = route.split('/');
  const indexOfInterfaces = params.indexOf('interfaces');
  if (indexOfInterfaces === -1) {
    return null;
  }
  const interfaceIdFromRoute = params[indexOfInterfaces + 1];

  if (getIsWhitelistedRoute(interfaceIdFromRoute, route)) {
    return null;
  }
  return interfaceIdFromRoute;
};
